"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.pxToRem = void 0;
function pxToRem(fontSizeInPx) {
    const htmlFontSize = 16;
    const fontSize = parseFloat(fontSizeInPx.trim());
    // Throws an error if the value of fontSize is anything apart from a number
    if (Number.isNaN(fontSize))
        throw new Error('Invalid px size');
    // Return the value as a string with rem appended to it
    return `${fontSize / htmlFontSize}rem`;
}
exports.pxToRem = pxToRem;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHhUb1JlbS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlscy9weFRvUmVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILFNBQWdCLE9BQU8sQ0FBQyxZQUFvQjtJQUMxQyxNQUFNLFlBQVksR0FBRyxFQUFFLENBQUM7SUFDeEIsTUFBTSxRQUFRLEdBQVcsVUFBVSxDQUFDLFlBQVksQ0FBQyxJQUFJLEVBQUUsQ0FBQyxDQUFDO0lBQ3pELDJFQUEyRTtJQUMzRSxJQUFJLE1BQU0sQ0FBQyxLQUFLLENBQUMsUUFBUSxDQUFDO1FBQUUsTUFBTSxJQUFJLEtBQUssQ0FBQyxpQkFBaUIsQ0FBQyxDQUFDO0lBQy9ELHVEQUF1RDtJQUN2RCxPQUFPLEdBQUcsUUFBUSxHQUFHLFlBQVksS0FBSyxDQUFDO0FBQ3pDLENBQUM7QUFQRCwwQkFPQyJ9